import React from 'react';
import { Route, IndexRoute,browserHistory } from 'react-router';
import App from './containers/app/App';
import ServiceRemoval from './containers/services/ServiceRemoval';
import NewGasLine from './containers/services/NewGasLine';
import Dashboard from './containers/common/Dashboard';
import ProjectDetails from './containers/common/ProjectDetails';
import Profile from './containers/common/account/Profile';
import Login from './containers/common/account/Login';
import ForgotPassword from './containers/common/account/ForgotPassword';
import ResetPassword from './containers/common/account/ResetPassword';
import VerifyEmail from './containers/common/VerifyEmail';
import ConfirmEmail from './containers/common/account/ConfirmEmail';
import Logout from './containers/common/account/Logout';
import Register from './containers/common/account/Register';

export default (
  <div>
    <Route path="/" component={App} history={browserHistory}>
      <IndexRoute component={NewGasLine} />
      <Route path="newgasline" component={NewGasLine} />
      <Route path="serviceremoval" component={ServiceRemoval} />
      <Route path="dashboard" component={Dashboard} />
      <Route path="projectdetails" component={ProjectDetails} />
      <Route path="profile" component={Profile} />
      <Route path="login" component={Login} />
      <Route path="forgotpassword" component={ForgotPassword} />
      <Route path="resetpassword" component={ResetPassword} />
      <Route path="verifyemail" component={VerifyEmail} />
      <Route path="confirmemail" component={ConfirmEmail} />
      <Route path="logout" component={Logout} />
      <Route path="register" component={Register} />
    </Route>
  </div>
);